export function buildCategoriesListTableHeaders({ t }) {
  return [
    {
      value: "id",
      text: t("categories.id"),
      thClass: "w-16",
      tdClass: "max-w-[2rem] min-w-[1rem]",
      disabled: true,
    },
    {
      value: "name",
      text: t("categories.name"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
      disabled: true,
    },
    {
      value: "sort",
      text: t("categories.position"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
    },
    {
      value: "parent",
      text: t("categories.parentCategory"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
    },
    {
      value: "status",
      text: t("categories.isActive"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
    },
    {
      value: "createdAt",
      text: t("categories.createdAt"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
    },
  ];
}
